import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage, intlShape } from 'react-intl'
import { Waypoint } from 'react-waypoint'

// Components
import { GemGrid } from 'src/Components/shared/Gem'
import { Panel, Format, InlineTextLock, Text } from 'src/Components'

// Constants
import { ScrolledIntoView, EVENTS_LABELS } from 'src/constants/trackingEvents'
import { EMERGENCY_RESERVE } from 'src/constants/gems'
import { USING_EQUITY_TOPIC_KEY } from 'src/constants/topicKeys'

// Utils
import { oneTimeTagEventDispatcher } from 'src/helpers/tagManager'
import { OVERLAY_HELPERS } from 'src/constants/navigation'

// Selectors
import { selectShouldRenderEmergencyReserve } from 'src/store/selectors/display'

// Styles
import styles from './CashOut.module.scss'

const scrollIntoView = oneTimeTagEventDispatcher(ScrolledIntoView, {
  eventLabel: EVENTS_LABELS.CashOutModule,
})

const CashOut = ({
  className,
  equity,
  gems,
  showDetail,
  selectedDetail,
  selectedGem,
  show,
  hide,
  question,
  locked,
  topic,
  intl,
}) => {
  const showReserve = useSelector(selectShouldRenderEmergencyReserve)

  const filteredGems = gems.filter(
    ({ key }) => key !== EMERGENCY_RESERVE || showReserve
  )

  return (
    <Panel data-qa='CashOutCard' className={classnames(styles.card, className)}>
      <Panel.Heading className={styles.heading} id='equity'>
        <FormattedMessage
          id='Homeowner.equity.heading'
          defaultMessage='Your house has built {equity} worth of equity. How could you use it?'
          values={{
            equity: (
              <Text variant='primary' element='span' nowrap>
                <Format.Currency>
                  <InlineTextLock enabled={Boolean(locked)}>
                    <Format.Number abbreviate value={equity} />
                  </InlineTextLock>
                </Format.Currency>
              </Text>
            ),
          }}
        />
      </Panel.Heading>
      <Waypoint onEnter={scrollIntoView} bottomOffset='75%'>
        <div />
      </Waypoint>
      <GemGrid
        className={styles.grid}
        data={filteredGems}
        selectedDetail={selectedDetail}
        selectedGem={selectedGem}
        show={show}
        hide={hide}
        collapsed={showDetail}
        question={question}
        topic={topic}
        topicKey={USING_EQUITY_TOPIC_KEY}
        overlayPanelName={OVERLAY_HELPERS.cashout.overlay}
        overlayPanelFrom={OVERLAY_HELPERS.cashout.getOrigin()}
        overlayPanelTitle={OVERLAY_HELPERS.getTitle('cashout', intl)}
      />
    </Panel>
  )
}

CashOut.propTypes = {
  className: PropTypes.string,
  equity: PropTypes.number,
  gems: PropTypes.array,
  showDetail: PropTypes.bool,
  selectedDetail: PropTypes.func,
  selectedGem: PropTypes.object,
  show: PropTypes.func,
  hide: PropTypes.func,
  question: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  locked: PropTypes.bool,
  topic: PropTypes.object,
  intl: intlShape,
}

export default CashOut
